/**
* アコーディオンのコンストラクタ
* @constructor
* @param {selector} el - セレクタ
*/
module.exports = Accordion = function(el, options){
  this.element = $(el);
  this.speed = (this.element.data('slidespeed')) ? this.element.data('slidespeed') : 200;
  this.target = this.element.data('acctarget');
  // console.log(this.target);
  this.targetEl = (this.target !== undefined) ? $('.js-AccordionTarget[data-acctarget="' + this.target + '"]') : this.element.next();
  this.trigger = this.element.data('acctrigger');
  this.options = options;
  if (this.options.parent === true) {
    this.parent = this.element.parent();
  }
  this.init();
};

Accordion.prototype.init = function(){
  var self = this;

  switch (self.trigger) {
    case 'hover':
      self.element.on('mouseenter touchstart', function(e) {
        e.preventDefault();
        self.event(true);
        // return false;
      });
      self.element.on('mouseleave', function(e) {
        e.preventDefault();
        self.event(false);
        // return false;
      });
      break;
    default:
      self.element.on('click', function(e) {
        e.preventDefault();
        self.event(null);
        return false;
      });
  }
};

Accordion.prototype.event = function(stat){
  var self = this;

  self.element.toggleClass('is-Open', stat);
  if (self.parent) {
    self.parent.toggleClass('is-Open', stat);
  }

  switch (stat) {
    case true:
      self.targetEl.slideDown(self.speed);
      break;
    case false:
      self.targetEl.slideUp(self.speed);
      break;
    default:
      self.targetEl.slideToggle(self.speed);
  }
};



//////////////////
// WEBPACK FOOTER
// ./js/_modules/accordion.js
// module id = 4
// module chunks = 0